module.exports = __webpack_public_path__ + "static/media/link-boomer-boutique.ed971dc6.png";